import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { Message, translator } from 'mage-i18n';
import { withPolling } from 'moet-core';
import { components as clientComponents } from 'mage-client';

import {
  IllustrationVerifyYourIdentity,
  IllustrationLearningAndDevelopment,
  Typography,
  SpacerVertical,
} from '@klarna/bubble-ui';
import { MessagingStep } from '@/components';
import { CAPS } from '@/constants';
import {
  getUserMerchantId,
  isMerchantApprovedForTransactions,
  merchantRegion,
} from '@/selectors/merchant';
import { isFetchingMerchant } from '@/selectors/loadingStates';

import { POLLING_INTERVAL, SLOW_POLLING_INTERVAL, T_PREFIX } from './constants';

export const ApplicationReview = ({ t, isApproved }) => (
  <MessagingStep
    illustration={
      isApproved ? <IllustrationLearningAndDevelopment /> : <IllustrationVerifyYourIdentity />
    }
    title={[t(`${T_PREFIX}.title${isApproved ? '_approved' : ''}`)]}
  >
    <SpacerVertical small />
    <Typography textToken="text-style/text/super-paragraphs/tall/regular">
      {!isApproved && <Message path={`${T_PREFIX}.message`} />}{' '}
      {t(`${T_PREFIX}.email_info_1`, {
        subject: (
          <strong key="email_subject">
            <Message path={`${T_PREFIX}.email_subject`} />
          </strong>
        ),
      })}{' '}
      {t(`${T_PREFIX}.email_info_2${isApproved ? '_approved' : ''}`)}
    </Typography>
  </MessagingStep>
);

ApplicationReview.propTypes = {
  isApproved: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

export default compose(
  connect(state => ({
    t: translator(state),
    mid: getUserMerchantId(state),
    isFetchingMerchant: isFetchingMerchant(state),
    isApproved: isMerchantApprovedForTransactions(state),
    merchantRegion: merchantRegion(state),
  })),
  clientComponents.withCapabilities({
    getMerchant: CAPS.V2_MERCHANTS_GET,
  }),
  withPolling(
    ({ getMerchant, mid, merchantRegion }) => {
      getMerchant({ needsProductRefresh: false, params: { mid }, region: merchantRegion });
    },
    ({ isFetchingMerchant: wasFetchingMerchant }, { isFetchingMerchant }) =>
      wasFetchingMerchant && !isFetchingMerchant,
    {
      exitCriteria: (_, { isApproved }) => isApproved,
      minDelayTime: POLLING_INTERVAL,
      maxDelayTime: SLOW_POLLING_INTERVAL,
      backoffOnTimeProgress: true,
    },
  ),
)(ApplicationReview);
